var _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMicrosoftTeams(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "abbd8bfa-be25-4d65-91c1-77722f7877ca",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 85.83 81.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bc59ba87-2eaa-4691-9f0d-eeb5b8baf699",
    x1: 7.63,
    y1: 2520.27,
    x2: 36.28,
    y2: 2470.64,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 2535.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a62c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4d55bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940ab"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M59.87,30.53H82a3.79,3.79,0,0,1,3.79,3.79h0v20.2A13.94,13.94,0,0,1,71.89,68.45h-.06A13.94,13.94,0,0,1,57.88,54.52h0v-22a2,2,0,0,1,2-2Z",
    style: {
      fill: "#5059c9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.85,
    cy: 17.56,
    r: 8.98,
    style: {
      fill: "#5059c9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.91,
    cy: 13.56,
    r: 12.97,
    style: {
      fill: "#7b83eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.21,30.53H27.61A3.75,3.75,0,0,0,24,34.37v23a22.51,22.51,0,0,0,22,23,22.52,22.52,0,0,0,22-23v-23A3.76,3.76,0,0,0,64.21,30.53Z",
    style: {
      fill: "#7b83eb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-4-7.4H91.82V88.41H-4Z",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9,30.53V62.81a3.66,3.66,0,0,1-2.27,3.37,3.62,3.62,0,0,1-1.38.28H25.71c-.26-.66-.5-1.32-.7-2A24.5,24.5,0,0,1,24,57.4v-23a3.75,3.75,0,0,1,3.66-3.83Z",
    style: {
      isolation: "isolate",
      opacity: 0.100000001490116
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.91,30.53V64.8a3.68,3.68,0,0,1-3.65,3.65H26.65c-.34-.65-.66-1.31-.94-2a19.83,19.83,0,0,1-.7-2A24.5,24.5,0,0,1,24,57.4v-23a3.75,3.75,0,0,1,3.66-3.83Z",
    style: {
      isolation: "isolate",
      opacity: 0.200000002980232
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.91,30.53V60.81a3.68,3.68,0,0,1-3.65,3.65H25A24.5,24.5,0,0,1,24,57.4v-23a3.75,3.75,0,0,1,3.66-3.83Z",
    style: {
      isolation: "isolate",
      opacity: 0.200000002980232
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.91,30.53V60.81a3.67,3.67,0,0,1-3.65,3.65H25A24.5,24.5,0,0,1,24,57.4v-23a3.75,3.75,0,0,1,3.66-3.83Z",
    style: {
      isolation: "isolate",
      opacity: 0.200000002980232
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9,20.21V26.5c-.33,0-.65,0-1,0s-.66,0-1,0a11.41,11.41,0,0,1-2-.32,13,13,0,0,1-9-7.63,11.54,11.54,0,0,1-.64-2h10A3.66,3.66,0,0,1,47.9,20.21Z",
    style: {
      isolation: "isolate",
      opacity: 0.100000001490116
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.91,22.21V26.5a11.41,11.41,0,0,1-2-.32,13,13,0,0,1-9-7.63h7.33A3.67,3.67,0,0,1,45.91,22.21Z",
    style: {
      isolation: "isolate",
      opacity: 0.200000002980232
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.91,22.21V26.5a11.41,11.41,0,0,1-2-.32,13,13,0,0,1-9-7.63h7.33A3.67,3.67,0,0,1,45.91,22.21Z",
    style: {
      isolation: "isolate",
      opacity: 0.200000002980232
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.91,22.21v4a13,13,0,0,1-9-7.63h5.33A3.67,3.67,0,0,1,43.91,22.21Z",
    style: {
      isolation: "isolate",
      opacity: 0.200000002980232
    }
  }), /*#__PURE__*/React.createElement("rect", {
    y: 18.55,
    width: 43.91,
    height: 43.91,
    rx: 3.66,
    style: {
      fill: "url(#bc59ba87-2eaa-4691-9f0d-eeb5b8baf699)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.59,32.48H24.27V52.4H19.61V32.48H12.33V28.62H31.59Z",
    style: {
      fill: "#fff"
    }
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftTeams);
export default __webpack_public_path__ + "static/media/microsoft_teams.371438c70cccf6e262cdd78815433f08.svg";
export { ForwardRef as ReactComponent };